import { DatePickerOpenDirective } from '../directives/date-picker-open.directive';
import { TerritorySplitEditorComponent } from './distributor-setup/territory-split-editor.component';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';
import { SheetResultComponent } from './distributor-setup/sheet-result.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapSelectDirective } from '../directives/bootstrap-select.directive';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { FormWizardModule } from 'angular2-wizard';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TreeTableModule } from 'primeng/treetable';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ExpenseComponent } from '../expenses/expense/expense.component';
import { TranslateModule } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { RatingModule } from 'primeng/rating';
import { CustomFieldInputsComponent } from './custom-field-inputs/custom-field-inputs.component';
import { CustomFieldValuesComponent } from './custom-field-values/custom-field-values.component';
import { CfValuePipe } from './custom-field-values/cf-value.pipe';
import { BuLevelPickerComponent } from './bu-level-picker/bu-level-picker.component';
import { EDetailingModalComponent } from './e-detailing-modal/e-detailing-modal.component';
import { ModalModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [BootstrapSelectDirective, DatePickerOpenDirective, ExpenseComponent, CustomFieldInputsComponent, CustomFieldValuesComponent, CfValuePipe, BuLevelPickerComponent, EDetailingModalComponent, TerritorySplitEditorComponent, SheetResultComponent, UploadProgressComponent],
  imports: [
    TranslateModule.forChild({}),
    CommonModule,
    FormsModule,
    TreeTableModule,
    TableModule,
    TreeModule,
    FormWizardModule,
    CheckboxModule,
    RadioButtonModule,
    NgMultiSelectDropDownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgbModule,
    AutoCompleteModule,
    DropdownModule,
    MultiSelectModule,
    UiSwitchModule,
    AccordionModule,
    CardModule,
    RatingModule,
    NgxDropzoneModule,
    DataTablesModule,
    ModalModule
  ],
  exports: [BootstrapSelectDirective, DatePickerOpenDirective,
    CustomFieldInputsComponent,
    CustomFieldValuesComponent,
    CfValuePipe,
    BuLevelPickerComponent,
    EDetailingModalComponent,
    TerritorySplitEditorComponent,
    UploadProgressComponent,
    SheetResultComponent,
    TreeTableModule,
    AccordionModule,
    CardModule,
    RatingModule,
    FormsModule,
    NgbModule,
    TableModule,
    NgMultiSelectDropDownModule,
    AutoCompleteModule,
    DropdownModule,
    MultiSelectModule,
    TreeModule,
    UiSwitchModule,
    BsDatepickerModule,
    NgxDropzoneModule, DataTablesModule]
})
export class TopSharedModule { }
